import { isEmpty } from "lodash";

export const getTabData = (isWired) => {
  const tabs = [
    {
      name: 'General',
      value: 'general',
      disabled: null,
      icon: null,
    },
    {
      name: 'Settings',
      value: 'settings',
      disabled: null,
      icon: null,
    },
    {
      name: 'Statistics',
      value: 'statistics',
      disabled: null,
      icon: null,
    }
  ];

  if (isWired) {
    tabs.splice(2, 1);
  }

  return tabs;
};

const getClientName = ({
  client
}) => {
  const { clientName, clientId } = client;
  const name = clientName || clientId || null; // Use mac address instead if the client name is empty.
  return name
}

const getFormattedInterface = ({
  client
}) => {
  const { band, ssid, interface: networkInterface } = client;

  if (isEmpty(networkInterface)) return "-";

  const isBandValid = !!band && band !== "";
  const isSSIDValid = !!ssid && ssid !== "";

  // Client type.
  const isWirelessType = isBandValid || isSSIDValid;

  const formattedInterface = isWirelessType ? networkInterface : (`Ethernet - Port ${networkInterface}`);

  return formattedInterface;
}

export const initClientData = ({
  responseData
}) => {
  const formattedName = getClientName({ client: responseData });
  const formattedInterface = getFormattedInterface({ client: responseData });

  return {
    ...responseData,
    formattedName,
    formattedInterface,
  }
}

export const getIsFormInvalid = (selectedClient) => {
  let isInvalid = false;
  if (selectedClient.clientName == null || selectedClient.clientName === "") isInvalid = true;

  return isInvalid;
}
